module.exports = __webpack_public_path__ + "img/user-guide-02-07-02.7e80802e.png";